import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentCopyOutlined } from '@mui/icons-material';
import { useToggle } from '@dfl/hook-utils';
import { HandlerError, IconButton } from '@dfl/mui-react-common';
import { LoadingButton } from '@mui/lab';
import { useCloneOffer } from '../../hooks/useCloneOffer';

type Props = {
  offerId: string;
  iconButton?: boolean;
};

const OfferCloneButton = ({ offerId, iconButton }: Props) => {
  const { t } = useTranslation('offerOrder');
  const { onOpen, onClose, isOpen } = useToggle();
  const { mutate, isPending, error } = useCloneOffer(offerId, onClose);

  return (
    <>
      {iconButton ? (
        <IconButton tooltip={t('clone.action')} onClick={onOpen}>
          <ContentCopyOutlined fontSize='small' color='primary' />
        </IconButton>
      ) : (
        <Button variant='contained' startIcon={<ContentCopyOutlined />} onClick={onOpen}>
          {t('clone.action')}
        </Button>
      )}

      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby='clone-dialog-title'
        aria-describedby='clone-dialog-description'
        maxWidth={'xs'}
        fullWidth
      >
        <DialogTitle sx={{ padding: '16px 16px 8px 16px' }} lineHeight={1.5} id='clone-dialog-title'>
          <Typography variant='h2'>{t('clone.title')}</Typography>
          <Typography color={'grey'} sx={{ mt: 0.5 }}>{t('clone.description')}</Typography>
        </DialogTitle>
        <DialogContent>
          <HandlerError error={error} />
        </DialogContent>
        <DialogActions>
          <Button variant='grey' onClick={onClose}>
            {t('common:cancel')}
          </Button>
          <LoadingButton
            onClick={() => { mutate(); }}
            autoFocus
            variant={'contained'}
            loading={isPending}
          >
            {t('common:confirm')}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default memo(OfferCloneButton);
